import styled, { css } from 'styled-components';
import { reviewFontText } from 'components/mixins/reviewTypography';
import Input from '../../login/Input';

export const FormTitle = styled.h3`
  ${reviewFontText};
  font-weight: 300;
  font-size: 13px;
  margin-bottom: 24px;
`;

export const LoginFormContainer = styled.div`
  width: 100%;
  ${FormTitle} {
    padding-bottom: 44px;
    margin-bottom: 0;
    font-size: 20px;
    text-align: center;
  }
  > div:not(:first-child) {
    padding: 0 0 43px;
    &:last-child {
      padding: 0 0 8px;
    }
  }
`;

export const LoginInput = styled(Input)`
  input {
    & + label {
      font-size: 15px;
    }
  }
`;

type LoginInputWrapperProps = {
  validationStatusBeforeSubmit: boolean;
};
export const LoginInputWrapper = styled.div<LoginInputWrapperProps>`
  > div {
    > div {
      left: 0;
      > span {
        top: -11px;
        font-size: 11px;
      }
      ${props =>
        props.validationStatusBeforeSubmit === false &&
        css`
          visibility: visible;
          top: 40px;
          > span {
            top: -6px;
            visibility: visible;
          }
        `}
    }

    input {
      width: 100%;
      height: 30px;
      background: #fff;
      ${reviewFontText};
      font-size: 15px;
      font-weight: 600;
      border: none;
      border-radius: 0;
      border-bottom: 1px solid #eaedf1;
      box-shadow: none;
      padding: 0 0 7px 0;

      &.is-empty {
        & + label {
          font-size: 15px;
          padding: 0;
        }

        &:focus {
          & + label {
            top: -15px;
            padding: 0;
            font-size: 11px;
          }
        }
      }

      &.full {
        &:valid {
          background-color: #fff;
          box-shadow: none;
          border: none;
          border-bottom: 1px solid #eaedf1;
        }
        &:invalid {
          background-color: #fff;
          box-shadow: none;
          border: none;
          border-bottom: 1px solid #f85d67;
        }
        &:hover {
          border-bottom: 1px solid #469dd5;
        }
        &:focus {
          border-bottom: 2px solid #469dd5;
          & + label {
            top: -15px;
            padding: 0;
            font-size: 11px;
          }
        }
        & + label {
          top: -15px;
          padding: 0;
          font-size: 11px;
        }
      }

      &:hover {
        border-bottom: 1px solid #469dd5;
      }

      &:focus {
        border: none;
        border-bottom: 2px solid #469dd5;
        box-shadow: none;
        & + label {
          top: -15px;
          padding: 0;
          font-size: 11px;
        }
      }

      ${props =>
        props.validationStatusBeforeSubmit === false &&
        css`
          & {
            border: none;
            border-bottom: 1px solid #f85d67;

            & + label {
              font-size: 15px;
              padding: 0;
            }

            &.full {
              &:invalid {
                border: none;
                border-bottom: 1px solid #f85d67;
                box-shadow: none;
                background: #fff;
              }
              border: none;
              border-bottom: 1px solid #f85d67;
            }

            &:hover,
            &:focus {
              border-bottom: 1px solid #f85d67;

              & + label {
                top: -15px;
                padding: 0;
                font-size: 11px;
              }
            }
          }
        `};
    }
  }
`;
